import { ColumnDef } from '@tanstack/react-table';
import { LOYALTY_LEVEL_TITLES } from 'pages/SubscriptionUsers/Statistics/constants';

function GetColumns(): ColumnDef<SubscriptionUsersStatisticsItem, string>[] {
  return [
    {
      header: 'Poziom lojalności',
      accessorKey: 'loyaltyLevel',
      cell: (info) => LOYALTY_LEVEL_TITLES[+info.getValue()],
    },
    {
      header: 'Liczba użytkowników',
      accessorKey: 'usersCount',
      cell: (info) => info.getValue(),
    },
    {
      header: 'Suma punktów',
      accessorKey: 'totalLoyaltyPoints',
      cell: (info) => info.getValue(),
    },
    {
      header: 'Punkty z aktywności',
      accessorKey: 'totalLoyaltyPointsFromActivities',
      cell: (info) => info.getValue(),
    },
    {
      header: 'Punkty z zakupów',
      accessorKey: 'totalLoyaltyPointsFromPurchases',
      cell: (info) => info.getValue(),
    },
    {
      header: '',
      accessorKey: 'action',
    },
  ];
}

export default GetColumns;
